import Component from 'gia/Component'
import render from '../components/render'
import stage from '../components/stage'
import _each from 'lodash.foreach'

class Video extends Component {

  constructor(element) {

    super(element)

    this.body = $('body')
    this.element = element
    this.el = $(element)



    this.ref = {
      video: [],
      videos: null,
      videoa: null
    }

  }


  mount() {

    var thiz = this

    this.videoa = $(this.ref.videos)


    _each(this.ref.video, (e)=>{
      $(e).on('click', (evt)=>{
        evt.preventDefault()
        $('.videos__player').addClass('is-active')
        var video =  e.dataset.provider == "youtube" ?  templateyoutube(e.dataset.video) : template(e.dataset.video, e.dataset.h)
        $('.player__container').empty().append(video)
      })
    })

    $('.player__close').on('click', (e)=>{
      $('.videos__player').removeClass('is-active')
      $('.player__container').empty()
    })


    // this.resizeQue = this.resize.bind(this)
    // stage.on("stage:resize", this.resizeQue);
    // this.renderQue = this.render.bind(this)
    // stage.on("stage:scroll", this.renderQue);
    // this.resize(stage);
  }

  render(){
    // const video = this.ref.videos.getBoundingClientRect()
    // const clip = mapNumberRange ((video.top / e.h) , 1, .2, 60, 3)
    // const clipa = limit(Math.round(clip), 8, 60)
    //
    // this.video.toggleClass('is-visible', clipa < 30 )
    // this.video.toggleClass('has-text', clipa < 10 )
  }

  unmount() {
    stage.removeAllListeners();
  }


  resize(e){

    // this.ref.container.dataset.h = $(this.ref.container).height()
    // this.ref.container.dataset.top = $(this.ref.container).offset().top
    this.render(e)

  }




}

let template = (video, h) => `<iframe src="https://player.vimeo.com/video/${video}?autoplay=1&amp;h=${h}&amp;app_id=122963" width="100%" height="100%" frameborder="0" allow="autoplay; fullscreen" allowfullscreen=""></iframe>`
let templateyoutube = (video)=> `<iframe width="100%" height="100%" src="https://www.youtube.com/embed/${video}" frameborder="0" allow="autoplay; encrypted-media; gyroscope" allowfullscreen></iframe>`

module.exports = Video
